module.exports = __webpack_public_path__ + "img/KidsStudyingfromHome2.9012db73.svg";